/* src/app/system-utils/rounded-checkbox/rounded-checkbox.component.scss */
.round {
  position: relative;
}
.round-small {
  position: relative;
}
.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 28px;
  left: 0;
  position: absolute;
  top: 0;
  width: 28px;
}
.round-small label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 18px;
  left: 0;
  position: absolute;
  top: 0;
  width: 18px;
}
.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 7px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}
.round-small label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 2px;
  opacity: 0;
  position: absolute;
  top: 4px;
  transform: rotate(-45deg);
  width: 12px;
}
.round input[type=checkbox] {
  visibility: hidden;
}
.round-small input[type=checkbox] {
  visibility: hidden;
}
.round input[type=checkbox]:checked + label {
  background-color: #66bb6a;
  border-color: #66bb6a;
}
.round-small input[type=checkbox]:checked + label {
  background-color: #66bb6a;
  border-color: #66bb6a;
}
.round input[type=checkbox]:checked + label:after {
  opacity: 1;
}
.round-small input[type=checkbox]:checked + label:after {
  opacity: 1;
}
/*# sourceMappingURL=rounded-checkbox.component.css.map */
